/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2021
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import BaseMoserObject from './BaseMoserObject';
//@import BaseMoserObject (loadtime) // superclass

export default class RelationshipUtils extends BaseMoserObject{

	/**
	 * Return true if two relationships are the same, false otherwise
	 * @param {Relationship} relationship1
	 * @param {Relationship} relationship2
	 * @return {boolean}  true if two relationships are the same, false otherwise
	 */
	static isEqual(relationship1, relationship2) {
		return RelationshipUtils._isEqualRef(relationship1.getLeft(), relationship2.getLeft()) && RelationshipUtils._isEqualRef(relationship1.getRight(), relationship2.getRight()) || RelationshipUtils._isEqualRef(relationship1.getLeft(), relationship2.getRight()) && RelationshipUtils._isEqualRef(relationship1.getRight(), relationship2.getLeft());
	}

	/**
	 * Two relationship ends are the same if their cardinality is the same and they are attached to the same table
	 * @return {boolean}  true if two relationship ends match, false otherwise
	 */
	static _isEqualCardinality(one, two) {
		return one == two || one.getRef() == two.getRef() && one.getMaxcard() === two.getMaxcard() && one.getMincard() === two.getMincard();
	}

	static _isEqualRef(one, two) {
		return one.getRef() == two.getRef();
	}

	/**
	 * Private constructor.
	 */
	//constructor() 
}


// WEBPACK FOOTER //
// ./src/generated/RelationshipUtils.js